export enum MLSort {
  'MOST_RELEVANT',
  'TOP_SELLERS',
  'SAVINGS_HIGH_TO_LOW',
  'PRICE_LOW_TO_HIGH',
  'PRICE_HIGH_TO_LOW',
  'TOP_RATED',
  'NEW_PRODUCTS',
  'BRAND',
}
export enum MLEventType {
  'CLICK' = 'C',
  'FAMILY' = 'F',
  'IMPRESSION' = 'I',
  'SEARCH' = 'S',
  'TEST' = 'T',
  'VIEW' = 'V',
}
export enum MLChannel {
  'AOS' = 'aos',
  'APP' = 'app',
  'CALIA' = 'calia',
  'STACKD' = 'stackd',
  'WEB' = 'web',
}
export enum MLStore {
  'DSG' = 'DSG',
  'FNS' = 'FNS',
  'GG' = 'GG',
  'PL' = 'PL',
}
export enum MLItemType {
  'BRAND' = 'B',
  'CATEGORY' = 'C',
  'KEYWORD' = 'K',
  'PRODUCT' = 'P',
}
export enum MLSearchType {
  'PLP' = 'PLP',
  'SRLP' = 'SRLP',
}
